/**
 * Users
 */

export class UsersHelper {
  static mapLabelsSeries(report: any) {
    const sums = report?.chart?.series?.map((item: any) => ({
      name: item.name,
      total: item.data.reduce((acc: any, value: any) => acc + value, 0),
    }));

    const seriesLabels = {
      labels: sums?.map((item: any) => item.name),
      series: sums?.map((item: any) => item.total),
    };
    return seriesLabels;
  }
}
